import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus';
import { debounce } from 'lib/misc';
import axios from 'axios';
import fpodb from '../../../db.json';

// NOTES:
// menu is broken down into primary, 2nd level, and 3rd level "panels" 
// primary: top level menu category (e.g. municipal water solutions, industrial measurement solutions)
// 2nd lvl: categories under the primary category (e.g. products, product lines)
// 3rd lvl: content inside the 2nd level category (e.g. meters, meter components, endpoints)

// "primary" and "secondary" menu panels/items are based on the 
// megamenu DOM order in megamenu.hbs. 

// on mobile, primary-menu-item ID is determined by DOM order. (e.g. the first item in the dom is primary-1, the second is primary-2, etc.)
// selectedSecondaryId is constructed from the secondary level ID and its parent, the selected primary Id (e.g. secondary-1-primary-2 refers to the 1st secondary category in the 2nd primary category)


const Megamenu = () => {

    const menu = document.querySelector('.megamenu');
    let historyArr = []
    let highestTierOpen   = 0;

    const clearMobileMenu = function()
        {
        historyArr.length = 0;
        highestTierOpen   = 0;
        const megaTiers       = document.querySelector('.mega__content .mega__tiers');
        const triggersWrap    = document.querySelector('.mega__triggers');
        const openTiers       = document.querySelectorAll('.mobileActiveTier') 
        const openCols        = document.querySelectorAll('.mobileActiveCol') 
        
        for(let i=0; i< openTiers.length; i++)                  // close all open mobile tiers (more than one might have been opened by desktop menu)
            {openTiers[i].classList.remove('mobileActiveTier')}
                
        for(let i=0; i< openCols.length; i++)                   // close all open mobile Cols (more than one might have been opened by desktop menu)
            {openCols[i].classList.remove('mobileActiveTier')}

        megaTiers.classList.add('mobileHide')                   // restore menu to default setting
        triggersWrap.classList.add('mobileActiveTier')
        }


    const megamenuConstructor = () => {         
        Vue.component('megamenu-template', {
            data: function() {
                return {
                    data: {
                        isMobile: store.state.isMobile,
                        selectedPrimaryId: null,
                        selectedSecondaryId: null,
                        selectedTopbarId: null,
                        mobileMenuOpen: false,
                        topbarMenuOpen: false, //topbar menu INSIDE the megamenu, not the one outside
                        primaryMenuOpen: false,
                        secondaryMenuOpen: false,
                        menuData: store.state.menuKeys,
                        searchOpen: false,
                        store: store,
                        scrollDir: null,
                    }
                }
            },
            computed: {
                computedIsMobile: function() {
                    return store.state.isMobile;
                },
                computedMenuData: function() {
                    return store.state.menuKeys;
                },
            },
            watch: {
                computedIsMobile: function() {
                    this.data.isMobile = this.computedIsMobile;
                    if (!this.data.isMobile) {
                        // close mobile menu if desktop
                        this.data.mobileMenuOpen = false;
                    } 
                    this.positionMenu();
                },
                computedMenuData: function() {
                    this.data.menuData = this.computedMenuData;
                },
                // handle closing megamenu on outside click
                "data.selectedPrimaryId": function() {
                    if (!this.data.isMobile) {
                        if (this.data.selectedPrimaryId !== null) {
                            document.addEventListener('click', this.outsideClick);
                        } else {
                            document.removeEventListener('click', this.outsideClick);
                        }
                    } else {
                        document.removeEventListener('click', this.outsideClick);
                    }
                },
                "data.scrollDir": function() {
                    let menuContainer = this.$el.parentNode;
                    // console.log(menuContainer);
                    switch (this.data.scrollDir) {
                        case "top":
                            menuContainer.classList.remove("hidden");
                            break;
                        case "up":
                            menuContainer.classList.remove("hidden");
                            break;
                        case "down":
                            menuContainer.classList.add("hidden");
                            break;
                        default:
                            return;
                    }
                }
            },
            methods: {
                toggleMobileMenu() {
                    this.data.mobileMenuOpen = !this.data.mobileMenuOpen; ///////////////////////////////////////////////////////////////////////////////
                    const isOpen = this.data.mobileMenuOpen 
                    if(isOpen == true)
                        {document.body.classList.add('mobile-open');}
                    else
                        {document.body.classList.remove('mobile-open');}
                    clearMobileMenu();
                },
                outsideClick(e) {
                    let target = e.target;
                    let megamenu = this.$el;
                    if (!megamenu.contains(target)) {
                        this.data.selectedPrimaryId = null;
                    }
                },
                positionMenu() {
                    let scrollPos = 0;
                    const handleScroll = () => {
                        if ((document.body.getBoundingClientRect()).top == 0) {
                            this.data.scrollDir = "top";
                        } else if ((document.body.getBoundingClientRect()).top > scrollPos) {
                            this.data.scrollDir = "up";
                        } else {
                            this.data.scrollDir = "down";
                        }
                        scrollPos = (document.body.getBoundingClientRect()).top;
                    }
                    // if (this.data.isMobile) {
                        window.addEventListener("scroll", handleScroll);
                    // } else {
                    //     window.removeEventListener('scroll', handleScroll);
                    // }
                },
                init() {
                    EventBus.$on('setTopbarSelection', (id) => {
                        this.data.selectedTopbarId = id;
                        this.data.topbarMenuOpen = true;
                        this.data.primaryMenuOpen = false;
                    });

                    /*
                    EventBus.$on('back', (obj) => {
                        let keys = Object.keys(obj);
                        keys.forEach((item, i) => {
                            this.data[item] = obj[item];
                        });
                    });

                    EventBus.$on('setPrimarySelection', (id) => {
                        this.data.selectedPrimaryId = id;
                        this.data.primaryMenuOpen = true;
                        this.data.topbarMenuOpen = false;
                    });

                    EventBus.$on('setSecondarySelection', (id) => {
                        this.data.selectedSecondaryId = id;
                    });
                    */
                }
            },
            mounted() {
                this.init();
                this.positionMenu();
            }
        });
         

        // wrapper for top level submenus
        // e.g. Municipal water solutions, Industrial measurement solutions
        /*
        Vue.component('megamenu-submenu', {
            props: ['data'],
            data: function() {
                return {
                    id: null,
                    isOpen: false,
                }
            },
            watch: {
                'data.selectedPrimaryId': function() {
                    this.isOpen = this.id == this.data.selectedPrimaryId ? true : false;
                }
            },
            methods: {

            },
            mounted() { 
                // set current submenu ID based on 1 index
                this.id = "submenu-" + ([].indexOf.call(this.$el.parentNode.children, this.$el));   
            }
        });
        */
       /*
        Vue.component('mobile-panel', {
            props: ['data'],
            data: function() {
                return {
                    
                }
            },
            methods: {

            },
            mounted() {

            }
        });
        */
        /*
        Vue.component('primary-menu-item', {
            props: ['isMobile'],
            data: function() {
                return {
                    id: null,
                    title: '',
                    suffix: null
                }
            },
            methods: {
                init() {
                    //  set =id
                    let menuItems = Array.from(document.querySelectorAll('.megamenu__mobile-item--main'));
                    this.id = "primary-" + (menuItems.indexOf(this.$el) + 1);
                    this.suffix = menuItems.indexOf(this.$el) + 1;
                    // set title
                    this.title = this.$el.innerText;
                    store.commit('updateMenu', {'id': this.id, 'title': this.title});

                    this.initEvents();
                },

                initEvents() {
                    this.$el.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (this.isMobile) {
                            this.handleMobileEvents(e)
                        } else {
                            // this.handleDesktopEvents(e);
                        }
                    });                    
                },
                // handleDesktopEvents(e) {
                //     EventBus.$emit('setSecondarySelection', `secondary-1-primary-${this.suffix}`);
                // },
                handleMobileEvents(e) {
                    // console.log("clicked");
                    EventBus.$emit('setPrimarySelection',this.id);
                },
            },
            mounted() {
                this.init();
            }
        });
        */
       /*
        Vue.component('primary-menu-item-desktop', {
            props: ['parent-id', 'data'],
            data: function() {
                return {
                    id: null,
                    isActive: false,
                }
            },
            watch: {
                parentId: function() {
                    this.id = "primary-" + this.parentId.slice(8);
                    this.initSubmenu();
                },
                'data.selectedPrimaryId': function() {
                    this.isActive = this.parentId == this.data.selectedPrimaryId ? true : false;
                }
            },
            methods: {
                initSubmenu(e) {
                    if(e) {e.preventDefault();}
                    if(!this.data.isMobile) {
                        EventBus.$emit('setSecondarySelection', `secondary-1-${this.id}`);
                    }
                },
                selectMenu() {
                    if (this.parentId == this.data.selectedPrimaryId) {
                        EventBus.$emit('setPrimarySelection', null);
                    } else {
                        EventBus.$emit('setPrimarySelection', `${this.parentId}`);
                        if(!this.data.isMobile) {
                            EventBus.$emit('setSecondarySelection', `secondary-1-${this.id}`);
                        }
                    }

                }
            },
            mounted() {

            }
        });
        */
       /*
        Vue.component('primary-panel', {
            props: ['parent-id', 'data'],
            data: function() {
                return {
                    id: null,
                    title: '',
                    isActive: false
                }
            },
            computed: {
                selectedId: function() {
                    return this.data.selectedPrimaryId;
                }
            },
            watch: {
                selectedId: function() {
                    this.isActive = this.selectedId == this.id ? true : false;
                }
            },
            methods: {
                init() {
                    let primaryPanels = Array.from(document.querySelectorAll('.megamenu__submenu-area-left'));
                    this.id = "primary-" + (primaryPanels.indexOf(this.$el) + 1);

                    this.getTitle();
                },
                back(e) {
                    // console.log('back');
                    e.preventDefault();
                    EventBus.$emit('back', {"primaryMenuOpen": false});
                },
                getTitle() {
                    let match = this.data.menuData.find(item => {
                        // console.log("item", item.id);
                        // console.log("id", this.id);
                        return item.id === this.id;
                    })

                    if (match) {
                        this.title = match.title;
                    }
                }
            },
            mounted() {
                this.init();
            }
        });
        */
        /*
        Vue.component('secondary-panel', {
            props: ['parent-id', 'data'],
            data: function() {
                return {
                    
                }
            },
            methods: {

            },
            mounted() {

            }
        });
        */
        /*
        Vue.component('secondary-content', {
            props: ['parentId', 'data'],
            data: function() {
                return {
                    id: null,
                    suffix: '',
                    isActive: false
                }
            },
            computed: {
                selectedId: function() {
                    return this.data.selectedSecondaryId;
                },
            },
            watch: {
                parentId: function() {
                    this.suffix = this.parentId.substring(8);
                    this.init();
                },
                selectedId: function() {
                    this.isActive = this.selectedId == this.id ? true : false;
                },
                // 'data.menuData': function() {
                //     this.getElements();
                // }
            },
            methods: {
                init() {
                    // set id
                    let items = Array.from(this.$el.parentNode.querySelectorAll('.megamenu__submenu-content'));
                    this.id = "secondary-" + (items.indexOf(this.$el) + 1) + "-primary-" + this.suffix;
                    this.$el.dataset.id = this.id;
                },
                // getElements() {
                //     let innerContent = this.$el.querySelector('.megamenu__inner-area');
                // }
            },
            mounted() {
            }
        });
        */
        /*
        Vue.component('secondary-menu-item', {
            props: ['parentId', 'data'],
            data: function() {
                return {
                    id: null,
                    title: '',
                    isActive: false
                }
            },
            computed: {
                selectedId: function() {
                    return this.data.selectedSecondaryId;
                }
            },
            // wait until parent has and ID to assign child id
            watch: {
                parentId: function() {
                    this.init();
                },
                selectedId: function() {
                    this.isActive = this.selectedId == this.id ? true : false;
                }
            },
            methods: {
                init() {
                    // set id
                    let items = Array.from(this.$el.parentNode.querySelectorAll('.megamenu__submenu-item'));
                    this.id = "secondary-" + (items.indexOf(this.$el) + 1) + "-" + this.parentId;
                    
                    this.$nextTick(() => {
                        let innerContent = document.querySelector(`div[data-id="${this.id}"]`).cloneNode(true);

                        this.title = this.$el.innerText;
                        store.commit('updateMenu', {"id": this.id,"title":this.title, "el":innerContent});
                    });

                    // set title
                },
                handleDesktop(e) {
                    e.preventDefault();
                    // console.log("clicked desktop");
                    EventBus.$emit('setSecondarySelection', this.id);
                },

                handleMobile(e) {
                    e.preventDefault();
                    // console.log("clicked mobile");
                    this.isActive = !this.isActive;
                    EventBus.$emit('setSecondarySelection', this.id);
                },
                initEvents() {
                    this.$el.querySelector('.megamenu__submenu-item-link').addEventListener('click', (e) => {
                        if (this.data.isMobile) {
                            this.handleMobile(e);
                        } else {
                            this.handleDesktop(e);
                        }
                    });
                }
            },
            mounted() {
                this.initEvents();
            }
        });
        */
        /*
        Vue.component('secondary-inner-content', {
            props: ['data', 'id'],
            data: function() {
                return {
                }
            },
            watch: {
                'data.menuData': function() {
                    this.initContent();
                }
            },
            methods: {
                initContent() {
                    let obj = this.data.menuData.find((item) => {
                        return item.id == this.id;
                    });
                    if (obj) {
                        let el = obj.el;
                        this.$refs.inner.appendChild(el);
                    }
                }
            },
            mounted() {
                // this.initContent();
            }
        });
        */
        Vue.component('topbar-panel', {
            props: ['data'],
            data: function() {
                return {
                }
            },
            methods: {
            },
            mounted() {

            }
        });

        Vue.component('topbar-content', {
            props: ['data'],
            data: function() {
                return {
                    menuData: store.state.menuKeys,
                    id: null,
                    isActive: false,
                    title: '',
                }
            },
            computed: {
                selectedId: function() {
                    return this.data.selectedTopbarId;
                },
                updatedMenuData: function() {
                    return store.state.menuKeys;
                }
            },
            watch: {
                // only watch the selected topbar content id
                selectedId: function() {
                    this.isActive = this.id == this.selectedId ? true : false;
                },
                updatedMenuData: function() {
                    this.menuData = store.state.menuKeys;
                    this.init();
                }
            },
            methods: {
                back(e) {
                    // console.log('back');
                    e.preventDefault();
                    EventBus.$emit('back', {"topbarMenuOpen": false})
                },
                init() {
                    let match = this.menuData.find(item => {
                        // console.log("item", item.id);
                        // console.log("id", this.id);
                        return item.id === this.id;
                    })

                    if (match) {
                        this.title = match.title;
                    }
                }
            },
            mounted() {
                let menuItems = Array.from(document.querySelectorAll('.megamenu__mobile-topbar'));
                this.id = "topbar-" + (menuItems.indexOf(this.$el) + 1);

                // console.log(this.menuData);
                // console.log("test",test);
            }
        });

        Vue.component('topbar-menu-item', {
            data: function() {
                return {
                    isMobile: store.state.isMobile,
                    id: null,
                    title: '',
                }
            },
            computed: {
                computedIsMobile: function() {
                    return store.state.isMobile;
                }
            },
            watch: {
                computedIsMobile: function() {
                    this.isMobile = this.computedIsMobile;
                    this.init();
                }
            },
            methods: {
                init() {
                    if (this.isMobile) {
                        // add event listeners
                        this.$el.addEventListener('click', (e) => {
                            e.preventDefault();
                            this.handleEvents(e)
                        });
                        this.setTitle();

                    } else {
                        // remove event listeners
                        this.$el.removeEventListener('click', (e) => {
                            this.handleEvents(e);
                        });
                    }
                },
                handleEvents(e) {
                    //console.log("clicked");
                    EventBus.$emit('setTopbarSelection',this.id);
                },
                // set section title to pass to section menu
                setTitle() {
                    this.title = this.$el.innerText;
                    store.commit('updateMenu', {"id": this.id,"title":this.title});
                }
            },
            mounted() {
                let menuItems = Array.from(document.querySelectorAll('.megamenu__mobile-item--topbar'));
                this.id = "topbar-" + (menuItems.indexOf(this.$el) + 1);
                this.init();
            }
        });

        Vue.component('lang-selector', {
            data: function() {
                return {
                    activeLang: null,
                    allLangs: [],
                    store: store
                }
            },
            methods: {
              
            },
            mounted() {
               
            }
        });

        Vue.component('lang-selector-item', {
            props: ['allLangs','activeLang'],
            data: function() {
                return {
                    lang: null,
                    isActive: false
                }
            },
            watch: {
                activeLang: function() {
                    this.isActive = this.activeLang === this.lang ? true : false;
                }
            },
            methods: {
                // changeLang(e) {
                //     // this.activeLang = this.lang;
                //     EventBus.$emit('set-lang', this.lang);
                // },
                selectLang(e) {
                    // this.activeLang = this.lang;
                    // EventBus.$emit('set-lang', this.lang);
                    let lang = e.currentTarget.dataset.lang;
                    if (lang) {
                        document.cookie = `selectedLanguage=${lang}; path=/; max-age=31536000;`;
                    }
                },
            
            
            },
            mounted() {
                this.lang = this.$el.getAttribute('href').slice(1).toLowerCase();
                this.isActive = this.activeLang == this.lang ? true : false;
            }
        });

        Vue.component('search', {
            props: ['data'],
            data: function() {
                return {
                    isOpen: false,
                    predictiveSearchOpen: false,
                    searchTerm: null, //from input for v-model
                    searchTermVis: null, //displayed search term
                    isLoading: null,
                    results: null,
                }
            },
            watch: {
                searchTerm: function() {
                    // init search if search term is longer than 1 character and not spaces
                    let self = this;
                    if (this.searchTerm && this.searchTerm.replace(/\s+/g, '') !== "" && this.searchTerm.length > 1) {
                        this.predictiveSearchOpen = true;
                        this.isLoading = true;
                        this.getResults();
                        // console.log(debounce);
                    } else {
                        this.predictiveSearchOpen = false;
                    }
                },
                isOpen: function() {
                    if (this.isOpen) {
                        this.$nextTick(() => {
                            this.$refs.globalSearch.focus();
                        });
                    }
                }
            },
            computed: {
                // includes url params for auto filtering on search results page
                // filters params are by filter ID
                searchUrl: function() {
                    return `${window.baseSearchUrl}?q=${this.searchTermVis}`;
                },
                productUrl: function() {
                    return `${window.baseProductUrl}&q=${this.searchTermVis}`;
                },
                documentationUrl: function() {
                    return `${window.baseDocumentationUrl}&q=${this.searchTermVis}`;
                },
                TechnologyUrl: function() {
                    return `${window.baseTechnologyUrl}&q=${this.searchTermVis}`;
                },
                language: function() {
                    return store.state.currentLang
                },
                taggingMeta: function() {
                    return JSON.stringify({
                        "type": "search",
                        "category": "Search",
                        "action": "Keywords",
                        "label": this.searchTermVis ? this.searchTermVis : "",
                        "filterName": "filtername"
                    })
                }
            },
            methods: {
                addLoading() {
                    document.querySelector('.megamenu__search-input').classList.add('loading');
                },
                removeLoading() {
                    document.querySelector('.megamenu__search-input').classList.remove('loading');
                },
                toggleSearch() {
                    this.isOpen = !this.isOpen;
                },
                submitSearch() {
                    // Handle Enter-to-search in JS instead of a native <form> submit.
                    // On pages with an outer page-level <form> (e.g. the backend/CMS), a
                    // nested <form> is invalid HTML and gets dropped by the browser, so the
                    // old form-based Enter submit never fired. Navigate directly instead.
                    let term = this.searchTerm ? this.searchTerm.trim() : "";
                    if (term === "") {
                        return;
                    }
                    // Same destination as the "All results" link (searchUrl), built from
                    // window.baseSearchUrl which is set by the backend.
                    window.location.href = `${window.baseSearchUrl}?q=${encodeURIComponent(term)}`;
                },
                getResults: debounce(function() {
                    this.addLoading();
                    this.searchTermVis = this.searchTerm;
                    let apiUrl = "/api/products";
                    // let apiUrl = "http://localhost:3003/products";
                    let self = this;
                    axios.get(apiUrl, {
                        params: {
                            q: this.searchTerm,
                            lang: this.language
                        }
                    })
                    .then(function(res) {
                        // console.log(res.data.results);
                        self.isLoading = false;
                        self.results = res.data.results.slice(0, 3);
                        self.removeLoading();
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
                }, 1000) 
            },
            mounted() {
            }
        });

        Vue.component('predictive-results', {
            props: ['results', 'isLoading'],
            data: function() {
                return {
                    
                }
            },
            template: `
            <div>
                <result-item v-for="(result, index) in results" :key="index" :content="result" :isLoading="isLoading"></result-item>
            </div>
            `,
            watch: {
                
            },
            methods: {
                
            },
            mounted() {

            }
        });

        Vue.component('result-item', {
            props: ['content', 'isLoading'],
            data: function() {
                return {
                    
                }
            },
            template: `
            <div class="megamenu__presearch-item">
                <div class="megamenu__presearch-item-image" v-if="content.productImageUrl">
                    <a :href="content.url"><img :src="content.productImageUrl" :alt="content.productImageUrlAltText"></a>
                </div>
                <div class="megamenu__presearch-item-content">
                    <a :href="content.url" class="megamenu__presearch-item-link"><span class="megamenu__presearch-item-eyebrow">
                    {{content.brand}}
                    </span>
                    <div class="megamenu__presearch-item-title" v-html="content.productName">
                    </div></a>
                </div>
            </div>
            `,
            watch: {
                
            },
            methods: {
                
            },
            mounted() {

            }
        });


        new Vue({
            el: `.megamenu`,
            store: store
        }).$mount(`.megamenu`, true);
    }


























    if (menu) 
        {
        megamenuConstructor();
        let hoverTimer        = null;
        const triggersWrap    = document.querySelector('.mega__triggers');
        const triggers        = document.querySelectorAll('.mega__triggers .is-trigger');
        const megaContent     = document.querySelector('.mega__content');
        const megaTiers       = document.querySelector('.mega__content .mega__tiers');
        const colTriggers     = document.querySelectorAll('.mega__content .trigger');
        const mobileBack      = document.querySelector('#mega__mobile__tier__back');
        const mobileHeading   = document.querySelector('#mega__mobile__tier__heading');

/////////////////////////////////////////////////////////////////////// click off menu 
document.addEventListener('click', e => 
    {
    // const clickedArea = 
    if (megaContent && !megaContent.contains(e.target) && !triggersWrap.contains(e.target) && megaContent.classList.contains('active'))
        {
        megaContent.classList.remove('active')
        triggersWrap.classList.remove('megamenuTriggered')
        document.querySelector('.mega__triggers .is-trigger.active').classList.remove('active')
        }
    })
/////////////////////////////////////////////////////////////////////// back button for mobile 
        if (mobileBack) {
            mobileBack.addEventListener('click',function(e)
                {
                e.preventDefault();
                const historySize = historyArr.length;                                                                          // this can also be the heighest tier open. 
                const curIndex    = historySize -1;

                // should only work if there is at least one item in history
                if( historySize > 1 )
                    {
                    const prevPlace = historyArr[curIndex -1]
                    // close current open tier, and open UL
                    document.querySelector(`.tier-${historySize}`).classList.remove('mobileActiveTier') 
                    document.querySelector(`.tier-${historySize} .mobileActiveCol`).classList.remove('mobileActiveCol')
                    // open  previous (in history)
                    document.querySelector(`.tier-${curIndex}`).classList.add('mobileActiveTier')
                    document.querySelector(`.tier-${curIndex} .mobileActiveCol`).classList.add('mobileActiveCol')
                    mobileHeading.innerText = prevPlace.txt
                    historyArr.length  = historySize -1;
                    }
                else if(historySize == 1)                                                                                      // history is back to default position
                    {
                    megaTiers.classList.add('mobileHide')
                    triggersWrap.classList.add('mobileActiveTier')
                    }
                }) 
        }
        





            

/////////////////////////////////////////////////////////////////////// open active tier for mobile
        const setMobileTier = function(tier, pos, historyText)
            {   
            const currentActive     = document.querySelector('.mobileActiveTier')
            const highestTierEl     = document.querySelector(`.tier-${tier}`)
            const activeColInTier   = document.querySelectorAll(`.tier-${tier} .mobileActiveCol`)
            
            // no tier lower than 0
            if(tier >=0 )
                {
                highestTierOpen= tier;
                currentActive.classList.remove('mobileActiveTier')
                }
            // close any active cols
            if(activeColInTier != undefined && activeColInTier.length>0)
                {
                for(let i=0;i<activeColInTier.length;i++)
                    {activeColInTier[i].classList.remove('mobileActiveCol')}
                }


            // if tier is bigger than zero show megacontent (where tiers/columns are)
            // and hide the trigger buttons
            if(tier >0 )
                {
                highestTierOpen= tier;
                triggersWrap.classList.remove('mobileActiveTier')
                megaTiers.classList.remove('mobileHide');
                historyArr[tier-1] = {txt: historyText, colPos:pos};

                if(pos != "fromBackButton")
                    {
                    document.querySelector(`.tier-${tier} .pos-${pos}`).classList.add('mobileActiveCol')
                    mobileHeading.innerText = historyText
                    }
                }
            else if (tier == 0)
                {
                highestTierOpen=0
                triggersWrap.classList.add('mobileActiveTier');
                megaTiers.classList.add('mobileHide');    
                }
            highestTierEl.classList.add('mobileActiveTier')
            }

        ////////////////////////////////////////////////////////////////////// open tiers/column logic
        const openTier=(triggerTier, posInTier, elClicked)=>
            {
            const maxDepth           = 4
            const thisTier           = parseInt(triggerTier)
            highestTierOpen          = thisTier + 1
            const nextTier           = ".tier-" + highestTierOpen
            const pos                = ".pos-" + posInTier;
            const currentPos         = document.querySelector(`${nextTier} .active`)
            const linkOpenSameTier   = document.querySelector(`.tier-${thisTier} .isOpen`)
            const linkOpenNextTier   = document.querySelector(`.tier-${thisTier+1} .isOpen`)
            const txt                = elClicked.innerText;
        
            // hide any opened items - in Same tier
            if(currentPos != undefined) 
                {
                currentPos.classList.remove('active');
                // same tier link needs to be cleared
                if(linkOpenSameTier != undefined)
                    {linkOpenSameTier.classList.remove('isOpen');}
                // next tier link needs to be cleared
                if(linkOpenNextTier != undefined)
                    {linkOpenNextTier.classList.remove('isOpen')}
        
                // hide any deeper columns (tiers)
                for (let i = (thisTier+1) ; i<= maxDepth; i++)
                    {
                    document.querySelector(`.tier-${i}`).classList.remove('active')
                    }
                }
        
            // open/re-open selection
            document.querySelector(nextTier).classList.add('active')
            document.querySelector(`${nextTier} ${pos}`).classList.add('active')
            elClicked.classList.add('isOpen')
            setMobileTier(highestTierOpen, posInTier, txt); 
            }

/* //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////  EVENTS */ 
/////////////////////////////////////////////////////////////////////// opening megamenu logic
        for(let i=0;i<triggers.length;i++)
            {
            triggers[i].addEventListener('click',function(e)
                    {
                    e.preventDefault()
                    // desktop logic
                    if (window.innerWidth > 1200) 
                            {
                            if(e.target.classList.contains("active") )
                                {
                                megaContent.classList.remove('active')
                                triggersWrap.classList.remove('megamenuTriggered')
                                e.target.classList.remove('active');
                                }
                            else
                                {
                                highestTierOpen = 1
                                const allActives      = document.querySelectorAll('.mega__content .active')              // select all open columns
                                const allopenArrows   = document.querySelectorAll('.mega__content .isOpen')              // my links that point to open columns   
                                const currentSelected = document.querySelector('.mega__triggers > li a.active')          // select open main tab
                                const target = e.target.dataset.target;
                                
                                // start by hiding all tiers 0 - 4
                                for(let i=0;i< allActives.length; i++)
                                        {allActives[i].classList.remove('active')}

                                // clear the main menu too
                                if(currentSelected != null)
                                    {
                                    currentSelected.classList.remove('active');
                                    }

                                // clear links to point to opened columns
                                for(let i=0;i< allopenArrows.length; i++)
                                    {allopenArrows[i].classList.remove('isOpen')}

                                e.target.classList.add('active')                                                        // highlight clicked tier 0
                                megaContent.classList.add('active')                                                     // open mega menu
                                triggersWrap.classList.add('megamenuTriggered')
                                document.querySelector(`.mega__content .tier-1 .pos-${target}`).classList.add('active') // open tier-1
                                }
                            }
                    // mobile logic
                        else
                            {
                            //mobileHeading.innerText = e.target.innerText;
                            const el = e.target
                            const targetPos = el.dataset.target
                            setMobileTier(1, targetPos , el.innerText);                                                                 // on mobile there is no toggle, this button always opens the next tier
                            }
                    })        
            }
        /////////////////////////////////////////////////////////////////////// submenu columns logic
        for(let i=0;i<colTriggers.length;i++)
            {
            colTriggers[i].addEventListener('mouseover',function(e)
                {
                e.preventDefault();
                const thisTier  = e.target.parentNode.parentNode.parentNode.dataset.tier;  // backwards: starting from link clicked to < li < ul < tier-#
                const posInTargetTier = e.target.dataset.target;
                const elClicked = e.target;
                if(window.innerWidth > 1200)
                    {
                    hoverTimer = setTimeout(function() 
                        {openTier( thisTier, posInTargetTier, elClicked) }, 500);
                    }
                }) 

            // cancel timer needed 
            colTriggers[i].addEventListener('mouseout',function(e)
                {   clearTimeout(hoverTimer); })   

            // click is ok for mobile
            colTriggers[i].addEventListener('click',function(e)
                {
                e.preventDefault();
                const thisTier  = e.target.parentNode.parentNode.parentNode.dataset.tier;  // backwards: starting from link clicked to < li < ul < tier-#
                const posInTargetTier = e.target.dataset.target;
                const elClicked = e.target;
                openTier( thisTier, posInTargetTier, elClicked)
                })   
            }
  
        }














    // window.baseDocumentationUrl = '/search-results?filters=111';
    // window.baseProductUrl = '/search-results?filters=222';
    // window.baseTechnologyUrl = '/search-results?filters=333';
    // window.baseSearchUrl = '/search-results'; 

}

export default Megamenu;
